<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5 mb-3">
                <div class="card">
                    <div class="card-header" id="header">
                        <h3>{{$t('pages.EventRegistration', {eventName: event.name})}}</h3>
                    </div>
                    <div class="card-body">
                        <div v-if="event && event.theme" class="mb-3">
                            <h3>{{ $t('fields.Theme') }}</h3>
                            <div>{{event.theme}}</div>
                        </div>
                        <div class="alert alert-info d-none" v-html="$t('eventRegistration.volunteerInfo')"></div>
                        <div class="alert alert-warning" v-if="displayFeeWarning">{{$t('eventRegistration.fee')}}</div>
                        <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
                        <div class="alert alert-danger" v-if="eventError">{{eventError}}</div>
                      <div class="alert alert-success" v-if="success">{{success}}</div>
                        <form @submit="submit" :style="'display:' + (success ? 'none' : 'block')" v-if="!eventError">
                            <formly-form :form="form" :model="model" :fields="fields" ref="register"/>
                            <img v-if="model.price.value === 117" src="https://s3.nl-ams.scw.cloud/org.domcek/media/influencer_tricko.jpg" alt="tabulka velkosti" />
                            <div class="text-right mt-4">
                                <button :class="(disabled ? 'disabled ': '') + 'btn btn-primary'" :disabled="disabled">
                                    {{ $t('button.Login') }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import dayjs from 'dayjs';
  import { mapGetters, mapActions } from 'vuex';
  import find from 'lodash/find';
  import {ERROR_MESSAGES, ROUTER_NAMES} from '../../constants';
  import { TRANSPORT_OPTIONS, TRANSPORT_TYPES, TRANSPORT_OPTIONS_WITHOUT_BUS } from '../../constants/eventContant';
  import validation from "../../utils/preDefinedValidation";
  import {years_check} from "../../utils/user";

  export default {
    mounted() {
      const volunteer = {
        label: this.$t('fields.AsVolunteer'),
        value: 'volunteer'
      }
      let options = [{
        label: this.$t('fields.AsParticipant'),
        value: 'participant'
      }];

      let birthDate = dayjs();
      if (this.user && this.user.profile) {
        birthDate = dayjs(this.user.profile.birth_date, 'YYYY-MM-DD');
      }
      const startDate = dayjs(this.event.start_date, 'YYYY-MM-DD');

      if (dayjs(this.event.end_volunteer_registration).add(1, 'day').isAfter(dayjs()) &&
        years_check(birthDate, 17, startDate)
        && this.user.participantionCount >= 3) {
        options = options.concat([volunteer])
      } else {
        this.fields[0].templateOptions.isDisabled = true;
      }

      this.fields[0].options = options
    },
    data() {
      this.event = find(this.$store.state.home.availableEvents, { id: parseInt(this.$route.params.eventId, 10) });
      let eventError = ""
      if (this.event.participantCount >= 100) {
        eventError = "Maximum učastnikou bol naplneni registracia už nieje možna"
      }
      let timesIn, timesOut, priceOptions = [];
      if (this.event.busInTimes && this.event.busInTimes.length) {
        timesIn = this.event.busInTimes.map((time) => {
          return {
            value: time.time,
            label: time.time
          };
        });
      }
      if (this.event.busOutTimes && this.event.busOutTimes.length) {
        timesOut = this.event.busOutTimes.map((time) => {
          return {
            value: time.time,
            label: time.time
          };
        });
      }
      if (this.event.prices) {
        priceOptions = this.event.prices.map((price) => {
          return {
            value: price.id,
            label: `${price.need_pay}€ - ${price.description}`
          }
        });
      }

      return {
        disabled: false,
        error: '',
        eventError,
        success: '',
        form: {
          event: null,
        },
        model: {
          volunteerType: '',
          type: {
            label: this.$t('fields.AsParticipant'),
            value: 'participant'
          },
          wantBeAnimatorOnPZ: false,
          volunteerTypeId: null,
          transportTimeOut: '',
          transportTimeIn: '',
          transportTypeIn: '',
          transportTypeOut: '',
          size: '',
          price: ''
        },
        fields: [
          {
            key: 'type',
            type: 'multi-select',
            templateOptions: {
              label: this.$t('fields.registerAs'),
              multiple: false,
              closeOnSelect: true
            },
            options: []
          },
          {
            key: 'volunteerType',
            type: 'multi-select',
            options: this.event.volunteerTypes ? this.event.volunteerTypes.map((type) => {
              return {
                value: type.id,
                label: type.name
              };
            }) : [],
            templateOptions: {
              label: this.$t('fields.volunteerType'),
              multiple: false,
              closeOnSelect: true
            },
            display: function (field, model) {
              return model.type && model.type.value === 'volunteer';
            },
            required: true
          },
           {
            key: 'wantBeAnimatorOnPZ',
            type: 'checkbox',
            templateOptions: {
              label: this.$t('fields.wantBeAnimatorOnPZ'),
            },
            display: (field, model) => {
                let birthDate = dayjs();
                if (this.user && this.user.profile) {
                    birthDate = dayjs(this.user.profile.birth_date, 'YYYY-MM-DD');
                }
                const startDate = dayjs(this.event.start_date, 'YYYY-MM-DD')

                return this.event.type === 'pz' && years_check(birthDate, 23, startDate) ;
            }
          },
          {
            key: 'transportTypeIn',
            type: 'multi-select',
            options: timesIn ? TRANSPORT_OPTIONS : TRANSPORT_OPTIONS_WITHOUT_BUS,
            required: true,
            templateOptions: {
              label: this.$t('fields.transportTypeIn'),
            }
          },
          {
            key: 'transportTimeIn',
            type: 'multi-select',
            options: timesIn,
            templateOptions: {
              label: this.$t('fields.transportTime'),
              multiple: false,
              closeOnSelect: true
            },
            display: (field, model) => {
              return model.transportTypeIn && model.transportTypeIn.value === TRANSPORT_TYPES.BUS;
            },
          },
          {
            key: 'transportTypeOut',
            type: 'multi-select',
            required: true,
            options: timesOut ? TRANSPORT_OPTIONS : TRANSPORT_OPTIONS_WITHOUT_BUS,
            templateOptions: {
              label: this.$t('fields.transportTypeOut'),
            },
          },
          {
            key: 'transportTimeOut',
            type: 'multi-select',
            options: timesOut,
            templateOptions: {
              label: this.$t('fields.transportTime'),
              multiple: false,
              closeOnSelect: true
            },
            required: false,
            display: (field, model) => {
              return model.transportTypeOut && model.transportTypeOut.value === TRANSPORT_TYPES.BUS;
            }
          },
          {
            key: 'price',
            type: 'multi-select',
            options: priceOptions,
            templateOptions: {
              label: this.$t('fields.Variant'),
              multiple: false,
              closeOnSelect: true
            },
            required: false,
            display: (field, model) => {
              return this.event.prices && this.event.prices.length > 1;
            }
          },
          {
            key: 'note',
            type: 'mce',
            templateOptions: {
              label: this.$t('fields.Note'),
              note: this.$t('eventRegistration.dietNote')
            }
          },
          {
            key: 'GDPRRegistration',
            type: 'checkbox',
            templateOptions: {
              label: this.$t('fields.GDPRRegistration'),
              atts: {
                name: 'newsletter'
              }
            },
            validators: {
              valid: validation.needToBeTrue
            }
          },
          {
            key: 'audioVisualKnowledgeAgreement',
            type: 'checkbox',
            templateOptions: {
              label: this.$t('fields.audioVisualKnowledgeAgreement'),
              atts: {
                name: 'newsletter'
              }
            },
            validators: {
              valid: validation.needToBeTrue
            }
          }
        ]
      };
    },
    computed: {
      ...mapGetters(['availableEvents', 'user']),
      eventId() {
        return this.$route.params.eventId;
      },
      displayFeeWarning() {
        return dayjs(this.event.end_registration).add(1, 'day').isBefore(dayjs());
      },
    },
    methods: {
      ...mapActions(['registerToEvent', 'userEvents']),
      submit(e) {
        e.preventDefault();
        this.error = null;
        this.$refs.register.validate()
          .then(() => {
            if (!this.form.$valid) return;
            if (this.model.price.value === 117 && (!this.model.size || (this.model.size &&!this.model.size.value))) {
              this.error = 'errorMessages.T_SHIRT_WARN';
              return
            }
            this.disabled = true;

            const price = this.event.prices && this.event.prices.length === 1 ? this.event.prices[0].id : null;

            this.registerToEvent({
              note: this.model.image === '' ? this.model.note : `${this.model.note}\n Potvrdenie: ${this.model.image}`,
              transportOut: this.model.transportTimeOut ? this.model.transportTimeOut.value : JSON.stringify(this.model.transportTypeOut.value),
              transportIn: this.model.transportTimeIn ? this.model.transportTimeIn.value : JSON.stringify(this.model.transportTypeIn.value),
              volunteerTypeId: this.model.volunteerType.value,
              wantBeAnimatorOnPZ: this.model.wantBeAnimatorOnPZ,
              audioVisualKnowledgeAgreement: this.model.audioVisualKnowledgeAgreement,
              GDPRRegistration: this.model.GDPRRegistration,
              eventId: this.eventId,
              priceId: this.model.price ? this.model.price.value : (price ? price : null),
            })
              .then(() => {
                this.$router.push({
                  name: ROUTER_NAMES.SUBSCRIBE_SUCCESS,
                })
              })
              .catch((err) => {
                this.disabled = false;
                if (err.response.status === 400) {
                  this.error = ERROR_MESSAGES.ALREADY_REGISTERED;
                } else {
                  this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
                }
                this.$scrollTo('#header', 500);
              });
          })
          .catch(() => {
            this.disabled = false;
          });
      },
    }
  };
</script>

<style scoped>

</style>
